export default __webpack_public_path__ + "static/media/devolution-sent.5cf2a6d4.svg";